import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  payload: null,
  key: ''
};
const drawer = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    showDrawer: (state, action) => {
      return action.payload;
    },
    hideDrawer: state => {
      return initialState;
    }
  }
});
export const { showDrawer, hideDrawer } = drawer.actions;
export default drawer;
